/**
 * 보안 파일 카드 컴포넌트
 */

import React from 'react';
import {
  File,
  FileText,
  Image,
  FileArchive,
  Download,
  Eye,
  Edit,
  Trash2,
  Shield,
  Share2,
  Calendar
} from 'lucide-react';

function SecureFileCard({ file, onDownload, onDelete, onPreview, onEdit }) {
  // 파일 아이콘 선택
  const getFileIcon = (mimeType) => {
    if (!mimeType) return File;
    
    if (mimeType.startsWith('image/')) return Image;
    if (mimeType.includes('pdf')) return FileText;
    if (mimeType.includes('zip') || mimeType.includes('rar')) return FileArchive;
    if (mimeType.includes('document') || mimeType.includes('text')) return FileText;
    
    return File;
  };

  // 파일 크기 포맷
  const formatFileSize = (bytes) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  // 날짜 포맷
  const formatDate = (date) => {
    if (!date) return '';
    const d = date.toDate ? date.toDate() : new Date(date);
    return d.toLocaleDateString('ko-KR');
  };

  // 카테고리 색상
  const getCategoryColor = (category) => {
    const colors = {
      document: '#4A90E2',
      image: '#7ED321',
      finance: '#F5A623',
      personal: '#BD10E0',
      work: '#50E3C2',
      other: '#9013FE'
    };
    return colors[category] || '#999';
  };

  const FileIcon = getFileIcon(file.mimeType);
  const isPreviewable = file.mimeType?.startsWith('image/') || 
                        file.mimeType?.includes('pdf') ||
                        file.mimeType?.startsWith('text/');

  return (
    <div className="secure-file-card">
      <div className="file-card-header">
        <div className="file-card-icon">
          <FileIcon size={24} />
        </div>
        <div className="file-card-actions">
          {file.isPinProtected && (
            <div className="security-badge" title="PIN 보호">
              <Shield size={12} />
            </div>
          )}
          {file.isShared && (
            <div className="security-badge" title="공유중">
              <Share2 size={12} />
            </div>
          )}
        </div>
      </div>

      <div className="file-card-body">
        <div className="file-card-name" title={file.originalName}>
          {file.originalName}
        </div>
        
        {file.description && (
          <div className="file-card-description">
            {file.description}
          </div>
        )}

        <div className="file-card-meta">
          <span className="file-size">{formatFileSize(file.fileSize)}</span>
          {file.category && (
            <span 
              className="file-category"
              style={{ 
                backgroundColor: `${getCategoryColor(file.category)}20`,
                color: getCategoryColor(file.category)
              }}
            >
              {file.category}
            </span>
          )}
        </div>
      </div>

      <div className="file-card-footer">
        <div className="file-date">
          <Calendar size={12} />
          <span>{formatDate(file.createdAt)}</span>
        </div>
        
        <div className="file-card-buttons">
          <button
            className="icon-button"
            onClick={(e) => {
              e.stopPropagation();
              onDownload();
            }}
            title="다운로드"
          >
            <Download size={16} />
          </button>
          
          {isPreviewable && (
            <button
              className="icon-button"
              onClick={(e) => {
                e.stopPropagation();
                onPreview();
              }}
              title="미리보기"
            >
              <Eye size={16} />
            </button>
          )}
          
          <button
            className="icon-button"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            title="수정"
          >
            <Edit size={16} />
          </button>
          
          <button
            className="icon-button danger"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            title="삭제"
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default SecureFileCard;